// src/components/ui/switch.tsx
import React from "react";

interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void; // Changed to a more semantic prop
  id?: string; // Optional for accessibility
  className?: string; // Optional for styling
  disabled?: boolean; // Added disabled prop
}

export const Switch: React.FC<SwitchProps> = ({
  checked,
  onCheckedChange,
  id,
  className,
  disabled,
}) => {
  return (
    <label
      className={`switch ${className || ""} ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
      htmlFor={id}
      style={{
        display: "inline-flex",
        alignItems:
          "center" /*, cursor: 'pointer' // Managed by className now */,
      }}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => {
          if (!disabled) {
            // Prevent change if disabled
            onCheckedChange(e.target.checked);
          }
        }}
        disabled={disabled} // Apply disabled to the input
        style={{ display: "none" }}
      />
      <span
        className="slider round"
        style={{
          display: "inline-block",
          width: "40px",
          height: "20px",
          background: checked
            ? disabled
              ? "hsl(20, 84%, 55%)"
              : "hsl(20, 84%, 45%)"
            : disabled
              ? "#e0e0e0"
              : "#ccc", // Using the primary HSL color from CSS vars
          borderRadius: "20px",
          position: "relative",
          transition: "background-color 0.3s, left 0.3s", // Added left to transition for smoother feel
        }}
      >
        <span
          style={{
            display: "block",
            width: "16px",
            height: "16px",
            background: "#fff",
            borderRadius: "50%",
            position: "absolute",
            top: "2px",
            left: checked ? "22px" : "2px",
            transition: "left 0.3s",
          }}
        ></span>
      </span>
    </label>
  );
};
